import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { mediaQueries } from "../../utils/device";
import TextSubHeading from "../textComponents/TextSubHeading";
import TextCaption2 from "../textComponents/TextCaption2";
import { colors, lightThemeObject } from "../../styleguide";
var pulse = keyframes(["0%{transform:scale(0.95);}100%{transform:scale(1);}"]);
var Wrapper = styled.div.withConfig({
  displayName: "PopoverCentered__Wrapper",
  componentId: "sc-4ghtox-0"
})(["box-sizing:border-box;display:flex;flex-direction:column;position:absolute;top:", ";bottom:", ";left:0px;padding:10px 16px;width:160px;background-color:var(--bui-background,", ");border:1px solid var(--bui-border,", ");border-radius:10px;animation:", ";animation-duration:0.5s;@media ", "{width:200px;left:unset;}&:before,&:after{content:'';position:absolute;", ";border-left:10px solid transparent;border-right:10px solid transparent;left:50%;transform:translate(-50%);}&:before{", ";", ";}&:after{", ";", ";z-index:1;}"], function (_ref) {
  var arrowBottom = _ref.arrowBottom,
      distance = _ref.distance;
  return !arrowBottom && distance && "".concat(distance, "px");
}, function (_ref2) {
  var arrowBottom = _ref2.arrowBottom,
      distance = _ref2.distance;
  return arrowBottom && distance && "".concat(distance, "px");
}, lightThemeObject['--bui-background'], lightThemeObject['--bui-border'], pulse, mediaQueries.large, function (_ref3) {
  var arrowBottom = _ref3.arrowBottom;
  return arrowBottom ? 'top: 100%' : 'bottom: 100%';
}, function (_ref4) {
  var arrowBottom = _ref4.arrowBottom;
  return arrowBottom ? "border-top: 10px solid var(--bui-border, ".concat(lightThemeObject['--bui-border'], ")") : "border-bottom: 10px solid var(--bui-border, ".concat(lightThemeObject['--bui-border'], ")");
}, function (_ref5) {
  var arrowBottom = _ref5.arrowBottom;
  return arrowBottom ? 'margin-top: 1px' : 'margin-bottom: 1px';
}, function (_ref6) {
  var arrowBottom = _ref6.arrowBottom;
  return arrowBottom ? "border-top: 10px solid ".concat(colors.white100) : "border-bottom: 10px solid ".concat(colors.white100);
}, function (_ref7) {
  var arrowBottom = _ref7.arrowBottom;
  return arrowBottom ? 'margin-top: 0px' : 'margin-bottom: 0px';
});
var Text = styled(TextCaption2).withConfig({
  displayName: "PopoverCentered__Text",
  componentId: "sc-4ghtox-1"
})(["@media ", "{font-size:15px;}"], mediaQueries.medium);

var PopoverCentered = function PopoverCentered(_ref8) {
  var heading = _ref8.heading,
      text = _ref8.text,
      _ref8$arrowPosition = _ref8.arrowPosition,
      arrowPosition = _ref8$arrowPosition === void 0 ? 'bottom' : _ref8$arrowPosition,
      distance = _ref8.distance;
  var arrowBottom = arrowPosition === 'bottom';
  return /*#__PURE__*/React.createElement(Wrapper, {
    arrowBottom: arrowBottom,
    distance: distance
  }, /*#__PURE__*/React.createElement(TextSubHeading, null, heading), text && /*#__PURE__*/React.createElement(Text, null, text));
};

PopoverCentered.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Optional heading
   */
  heading: PropTypes.string,

  /**
   * Optional text
   */
  text: PropTypes.string,

  /**
   * arrow placed on bottom/top
   */
  arrowPosition: PropTypes.oneOf(['bottom', 'top']),

  /**
   * Optional distance (margin below vs on top depending on arrowPosition)
   */
  distance: PropTypes.number
} : {};
export default PopoverCentered;
//# sourceMappingURL=PopoverCentered.js.map